<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card no-body class="p-4">
            <b-card-body>
              <h1>FATOS ADMIN</h1>
              <p class="text-muted">로그인 후 이용이 가능합니다.</p>
              <b-input-group class="mb-3">
                <b-input-group-prepend><b-input-group-text><i class="fa fa-user"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input type="text" v-model="loginId" placeholder="Login ID" @keyup.enter.native="handleLoginClicked"/>
              </b-input-group>
              <b-input-group class="mb-4">
                <b-input-group-prepend><b-input-group-text><i class="fa fa-lock"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input type="password" v-model="password" placeholder="Password" @keyup.enter.native="handleLoginClicked"/>
              </b-input-group>
              <b-row>
                <b-col cols="12">
                  <b-button v-ripple variant="primary" class="px-4" v-on:click="handleLoginClicked">로그인</b-button>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loginId: '',
      password: ''
    }
  },
  methods: {
    // 로그인에 성공한 경우 적절한 페이지로 이동한다
    redirect () {
      let query = window.location.href.split('?')
      let items = query[1].split('&')
      let returnPath = null
      for (let i = 0; i < items.length; i++) {
        let params = items[i].split('=')
        if (params[0] === 'returnPath') {
          returnPath = decodeURIComponent(params[1])
          break
        }
      }
      if (returnPath) {
        this.$router.push('/' + returnPath)
      } else {
        this.$router.push('/site')
      }
    },

    /**
     * <로그인 화면> 이벤트 처리 메소드
     */
    // 로그인 버튼 클릭 시
    handleLoginClicked (event) {
      // event.preventDefault()
      // 입력값 체크
      if (!this.$data.loginId || this.$data.loginId.length < 2) {
        this.$toasted.global.info('아이디를 2자이상 입력하세요.')
        return false
      }
      if (!this.$data.password || this.$data.password.length < 2) {
        this.$toasted.global.info('비밀번호를 2자이상 입력하세요.')
        return false
      }
      // 로그인 요청
      let params = {
        loginId: this.$data.loginId,
        password: this.$data.password
      }
      this.$store.dispatch('doLogin', params)
        .then((response) => {
          this.redirect()
        })
        .catch((error) => {
          this.$toasted.global.error(this.formatErrorMessage(error))
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue